import React from "react";

export const OpsDashboard = () => {
  // Pass the backend host to the iframe via query string so its fetches hit the
  // actual backend (where the auth cookie lives), not the static-asset host.
  const apiBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  const iframeSrc = apiBase
    ? `/ops-dashboard.html?api=${encodeURIComponent(apiBase)}`
    : "/ops-dashboard.html";

  return (
    <div data-testid="ops-dashboard-container" className="w-full -mx-4 sm:-mx-6 lg:-mx-8 -my-8">
      <iframe
        title="Stryde Ops Dashboard"
        src={iframeSrc}
        data-testid="ops-dashboard-iframe"
        className="w-full"
        style={{
          height: "calc(100vh - 80px)",
          border: "none",
          display: "block",
        }}
      />
    </div>
  );
};

export default OpsDashboard;
